import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@assets/images/project/icon-0-back.png';
import _imports_1 from '@assets/images/project/icon-0-home.png';
import _imports_2 from '@assets/images/project/icon-0-share.png';
const _withScopeId = n => (_pushScopeId("data-v-12fb7137"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "project-header",
  ref: "box"
};
const _hoisted_2 = {
  class: "btn-compose",
  ref: "btnCompose"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0
}, null, -1));
const _hoisted_4 = [_hoisted_3];
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1
}, null, -1));
const _hoisted_6 = [_hoisted_5];
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2
}, null, -1));
const _hoisted_8 = [_hoisted_7];
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-mineweibo"
}, null, -1));
const _hoisted_10 = [_hoisted_9];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [!$props.hide_back ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "btn-item back",
    onClick: _cache[0] || (_cache[0] = $event => $options.onBack())
  }, _hoisted_4)) : _createCommentVNode("", true), _createElementVNode("div", {
    class: _normalizeClass(['pro_name', {
      'idea_title': $props.is_idea
    }]),
    ref: "proName"
  }, _toDisplayString($props.name), 3), !$props.is_idea ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: "btn-item home",
    onClick: _cache[1] || (_cache[1] = $event => $options.onLinkHome())
  }, _hoisted_6)) : _createCommentVNode("", true), _createElementVNode("div", {
    class: "btn-item share",
    onClick: _cache[2] || (_cache[2] = $event => $options.onShare())
  }, _hoisted_8), $props.hide_back ? (_openBlock(), _createElementBlock("div", {
    key: 2,
    class: "btn-item user-center",
    onClick: _cache[3] || (_cache[3] = $event => $options.onUserCenter())
  }, _hoisted_10)) : _createCommentVNode("", true)], 512)], 512);
}